import { render } from "./NavBarAccount.vue?vue&type=template&id=348e2616&scoped=true"
import script from "./NavBarAccount.vue?vue&type=script&lang=js"
export * from "./NavBarAccount.vue?vue&type=script&lang=js"

import "./NavBarAccount.vue?vue&type=style&index=0&id=348e2616&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348e2616"]])

export default __exports__